export default "__VITE_ASSET__DURS$1am__"